export default "__VITE_ASSET__D1ibwa5q__"